import { CheckOutlined, CloseOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Select } from "antd";
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { trangThaiDangKyDaoTao } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { lanhDaoPhongDuyetCTDangKyDaoTao, lanhDaoPhongTrinhDangKyDaoTao, layDSDuyetDangKyDaoTao, layDsTongHopDangKyDaoTao } from '../../services/daotao';
import { layDsNLDTheoIdDonVi } from '../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ViewDangKyDaoTaoTable from './ViewDangKyDaoTaoTable';

const DuyetDangKyDaoTao = () => {
    const dispatch = useDispatch();
    const [dataTable, setDataTable] = useState<Array<any>>([]);
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.DangKyDaoTao.PheDuyetCaNhan]);
    const params = new URLSearchParams(window.location.search);
    const namParam = params.get("nam") || new Date().getFullYear().toString();
    const [nam, setNam] = useState<string>(namParam);
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs(namParam));
    const idDotParam = parseInt(params.get("idDangKyDaoTaoNam")) || 0;
    const [idDot, setIdDot] = useState<number>(idDotParam);
    const [dsDot, setDsDot] = useState<Array<any>>([]);
    // đã tải xong danh sách đợt hay chưa (phân biệt "đang tải" với "tải xong nhưng rỗng")
    const [daTaiDsDot, setDaTaiDsDot] = useState<boolean>(false);

    const [confirmModal, setConfirmModal] = useState<any>({});
    const [lyDo, setLyDo] = useState<string>("");
    // các chi tiết đăng ký (lớp của từng nhân viên) đang được chọn trong bảng
    const [dsChon, setDsChon] = useState<Array<any>>([]);
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;

    // danh sách đợt đăng ký của năm đang chọn
    const dsDotTheoNam = dsDot
        .filter(x => dayjs(x.nam).format('YYYY') === nam)
        .map(x => ({
            value: x.id,
            label: x.ten ? `${x.ten} (${dateCommon.formatDate(x.ngayBatDau)} - ${dateCommon.formatDate(x.ngayKetThuc)})` : `Đợt ${dateCommon.formatDate(x.ngayBatDau)} - ${dateCommon.formatDate(x.ngayKetThuc)}`
        }));

    const layDsDot = async () => {
        try {
            const rs = await layDsTongHopDangKyDaoTao();
            setDsDot(rs || []);
            // việc chọn đợt mặc định do useEffect [nam, idDot, daTaiDsDot] xử lý,
            // đồng thời tôn trọng idDot đã lấy từ param
        } catch (err: any) {
            toast.error(err);
        } finally {
            setDaTaiDsDot(true);
        }
    };

    const layDuLieu = async (thoiGian: string, idDangKyDaoTaoNam: number) => {
        try {
            dispatch(showLoadingScreen());
            const rs = await layDSDuyetDangKyDaoTao(thoiGian, idDangKyDaoTaoNam);

            setDataTable(rs || []);
            // bảng tự bỏ chọn khi đổi bộ dữ liệu => đồng bộ lại danh sách chọn ở đây
            setDsChon([]);
        } catch (err: any) {
            toast.error(err);
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    const onChange: DatePickerProps['onChange'] = (year) => {
        const yearStr = year?.format('YYYY');
        if (yearStr && yearStr !== nam) {
            setNamValue(year);
            setNam(yearStr);
            // đổi năm thì bỏ đợt đã chọn của năm cũ
            setIdDot(0);
        }
    };

    const eventChuyenVanPhong = async () => {
        var dsNhanVien = await layDsNLDTheoIdDonVi(user.idDonVi);
        var dsNhanVienThieu = dsNhanVien.filter(nhanVien =>
            !dataTable.some(x => x.idNhanVien === nhanVien.id)
        ).map(nhanvien => nhanvien.hoTen);
        setConfirmModal({
            isShowModal: true,
            title: "Chuyển tiếp",
            content:
                <>
                    {dsNhanVienThieu.length > 0 && <p> <label>Danh sách nhân viên đăng ký nhu cầu đào tạo còn thiếu:</label> {dsNhanVienThieu.join(", ")}.</p>}
                    Bạn có muốn <label>Chuyển tiếp</label> danh sách đăng ký này lên Văn phòng không?
                </>,
            onSubmit: chuyenVanPhong
        });
    };
    const chuyenVanPhong = async () => {
        dispatch(showLoadingScreen());
        try {
            var request = {
                ids: [...new Set(
                    dataTable
                        .filter(x => (
                            (
                                x.idNhanVien == user.idNhanVien &&
                                user.isLanhDaoPhong &&
                                [trangThaiDangKyDaoTao.khoiTao, trangThaiDangKyDaoTao.lanhDaoQuyTuChoi].includes(x.trangThai)
                            )
                            ||
                            (
                                x.idNhanVien != user.idNhanVien &&
                                [trangThaiDangKyDaoTao.duyetCapPhong, trangThaiDangKyDaoTao.lanhDaoQuyTuChoi].includes(x.trangThai)
                            )
                        ))
                        .map(x => x.id)
                )]
            };
            await lanhDaoPhongTrinhDangKyDaoTao(request);
            toast.success("Thao tác thành công");
            layDuLieu(nam, idDot);
        } catch (ex) {
            toast.error("Thao tác không thành công");
        }
        dispatch(hideLoadingScreen());
    }
    // các lớp đang chọn mà lãnh đạo phòng được phép duyệt / từ chối
    const dsChonHopLe = dsChon.filter(x =>
        [trangThaiDangKyDaoTao.trinhLanhDaoPhong, trangThaiDangKyDaoTao.lanhDaoQuyTuChoi].includes(x.trangThai)
    );

    /**
     * Mở popup xác nhận Duyệt / Từ chối các lớp đang được chọn
     */
    const eventDuyetChiTiet = (isDuyet: boolean) => {
        if (dsChonHopLe.length === 0) {
            toast.warning("Vui lòng chọn ít nhất một lớp đang chờ duyệt");
            return;
        }
        setLyDo("");
        setConfirmModal({
            isShowModal: true,
            title: isDuyet ? "Duyệt đăng ký đào tạo" : "Từ chối đăng ký đào tạo",
            content:
                <>
                    Bạn có muốn <label>{isDuyet ? "Duyệt" : "Từ chối"}</label> {dsChonHopLe.length} thông tin đã chọn không?
                </>,
            showLyDo: true,
            batBuocLyDo: !isDuyet,
            onSubmit: (currentLyDo: string) => duyetChiTiet(isDuyet, currentLyDo)
        });
    };

    const duyetChiTiet = async (isDuyet: boolean, currentLyDo?: string) => {
        dispatch(showLoadingScreen());
        try {
            await lanhDaoPhongDuyetCTDangKyDaoTao({
                isDuyet: isDuyet,
                lyDo: currentLyDo || lyDo,
                danhSachDuyet: dsChonHopLe.map(x => x.idChiTiet)
            });
            toast.success(isDuyet ? "Duyệt đăng ký đào tạo thành công" : "Từ chối đăng ký đào tạo thành công");
            setLyDo("");
            layDuLieu(nam, idDot);
        } catch (ex: any) {
            toast.error(ex?.message || "Thao tác không thành công");
        }
        dispatch(hideLoadingScreen());
    };

    useEffect(() => {
        layDsDot();
    }, []);
    useEffect(() => {
        // chờ danh sách đợt tải xong mới xử lý, tránh reset idDot lấy từ param
        if (!daTaiDsDot) return;
        if (dsDotTheoNam.length > 0) {
            if (idDot > 0) {
                layDuLieu(nam, idDot);
            } else {
                const value = dsDotTheoNam[0].value;
                setIdDot(value);
                layDuLieu(nam, value);
            }
        } else {
            // đã tải xong nhưng không có đợt nào (kể cả ds thật sự rỗng) => clear
            setIdDot(0);
            setDataTable([]);
            setDsChon([]);
        }
    }, [nam, idDot, daTaiDsDot]);
    const isValidTrangThai = (item: any) =>
        [
            trangThaiDangKyDaoTao.duyetCapPhong,
            trangThaiDangKyDaoTao.lanhDaoPhongTuChoi,
            trangThaiDangKyDaoTao.chuyenVanPhong,
            trangThaiDangKyDaoTao.lanhDaoQuyTuChoi,
            trangThaiDangKyDaoTao.pheDuyet
        ].includes(item.trangThai) ||
        (item.idNhanVien === user.idNhanVien &&
            item.trangThai === trangThaiDangKyDaoTao.khoiTao);

    const isCoTheChuyen = (item: any) =>
        item.trangThai === trangThaiDangKyDaoTao.duyetCapPhong ||
        (item.idNhanVien === user.idNhanVien &&
            item.trangThai === trangThaiDangKyDaoTao.khoiTao);

    const allValid = dataTable.every(isValidTrangThai);
    const hasItemToChuyen = dataTable.some(isCoTheChuyen);
    // có ít nhất 1 lớp đang trình lãnh đạo phòng thì mới cho Duyệt / Từ chối
    const coTheDuyet = dataTable.some(x => x.trangThai === trangThaiDangKyDaoTao.trinhLanhDaoPhong);

    const chuyenVP = user.isLanhDaoPhong && allValid && hasItemToChuyen;
    return (
        <section>
            <ContentHeader title="Duyệt Đăng ký đào tạo" />

            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    if (confirmModal.batBuocLyDo && !lyDo.trim()) {
                        toast.warning("Vui lòng nhập lý do từ chối");
                        return;
                    }
                    confirmModal.onSubmit(lyDo);
                    setConfirmModal({ isShowModal: false });
                }}
            >
                <Row>
                    <Col span="24">
                        {confirmModal.content}
                    </Col>
                </Row>
                {
                    confirmModal.showLyDo &&
                    <Row>
                        <Col span="24" className="form-group">
                            <label>Lý do {confirmModal.batBuocLyDo && <span className="text-red">*</span>}</label>
                            <Input.TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => setLyDo(e.target.value)}
                            />
                        </Col>
                    </Row>
                }
            </ModalTextForm>
            <Row className="form-group" gutter={8}>
                <Col span={4}>
                    <DatePicker
                        changeOnBlur
                        value={namValue}
                        style={{ width: "100%" }}
                        placeholder="Chọn năm"
                        picker="year"
                        format={namFormat}
                        onChange={onChange}
                    />
                </Col>
                <Col span={8}>
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Tất cả đợt đăng ký"
                        value={idDot > 0 ? idDot : undefined}
                        options={dsDotTheoNam}
                        onChange={(value) => setIdDot(value || 0)}
                        notFoundContent="Không có đợt đăng ký nào"
                    />
                </Col>
                {
                    // button của Lãnh đạo phòng
                    user.isLanhDaoPhong &&
                    <Col span={12}>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                            {
                                coTheDuyet &&
                                <>
                                    <Button
                                        type="primary"
                                        icon={<CheckOutlined rev="" />}
                                        className="hrm-btn"
                                        disabled={dsChonHopLe.length === 0}
                                        onClick={() => eventDuyetChiTiet(true)}
                                    >
                                        Duyệt
                                    </Button>
                                    <Button
                                        type="primary"
                                        danger
                                        icon={<CloseOutlined rev="" />}
                                        className="hrm-btn"
                                        disabled={dsChonHopLe.length === 0}
                                        onClick={() => eventDuyetChiTiet(false)}
                                    >
                                        Từ chối
                                    </Button>
                                </>
                            }
                            {
                                chuyenVP &&
                                <Button
                                    type="primary"
                                    icon={<SendOutlined rev="" />}
                                    className="hrm-btn"
                                    onClick={eventChuyenVanPhong}
                                >
                                    Chuyển văn phòng
                                </Button>
                            }
                        </div>
                    </Col>
                }
            </Row>

            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <ViewDangKyDaoTaoTable
                            dataTable={dataTable}
                            onSelectedChange={setDsChon}
                            coTheGop={user.isLanhDaoPhong}
                            onReload={() => layDuLieu(nam, idDot)}
                        />
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DuyetDangKyDaoTao;